<template>
  <pt-previous-video class="pt-previous-video__withData"></pt-previous-video>
</template>

<script>
import PtPreviousVideo from './index'
export default {
  name: 'pt-previous-video__withData',
  components: {
    'pt-previous-video': PtPreviousVideo
  }
}
</script>
